<app-manually-uploaded-consult-notes [disableEhrToggles]="true" />
